module.exports = __webpack_public_path__ + "static/media/kekemotsu.ac977ca6.png";